<template>
  <v-app>
    <v-app-bar flat class="primary">
      <v-app-bar-nav-icon @click.native="drawer = !drawer"></v-app-bar-nav-icon>
        <v-btn text href="/">
          <v-toolbar-title
            style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color: white"
          >
            <v-icon large>
              mdi-youtube
            </v-icon>
            YouTeam
          </v-toolbar-title>
        </v-btn>
        <v-spacer></v-spacer>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      color="secondary"
      absolute
      bottom
      temporary
    >
      <div v-for="item in items" :key="item.title" class="my-2">
        <v-list-item :to="item.route" active-class="white--text grey darken-2" class="mx-2">
          <v-icon class="mr-2">{{item.icon}}</v-icon>
          <v-list-item-title style="font-size:18px" class="text--text">{{item.title}}</v-list-item-title>
        </v-list-item>
      </div>
      <v-list-item v-if="userIsAuthenticated" @click="onLogOut" class="mx-2">
        <v-icon class="mr-2">mdi-logout</v-icon>
        <v-list-item-title style="font-size:18px" class="text--text">Log Out</v-list-item-title>
      </v-list-item>
      <v-spacer></v-spacer>
      <v-switch
        v-model="$vuetify.theme.dark"
        class="mx-4"
        hide-details
        label="Dark Theme"
      ></v-switch>
    </v-navigation-drawer>
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  title: 'YouTeam',
  theme: vm => ({
    initialDark: vm.$vuetify
      ? vm.$vuetify.theme.dark
      : false
  }),

  data: () => ({
    drawer: false
  }),
  computed: {
    items () {
      let items = [
        { title: 'Sign up', icon: 'mdi-account-plus', route: '/signup' },
        { title: 'Log in', icon: 'mdi-login', route: '/login' }
      ]
      if (this.userIsAuthenticated) {
        items = [
          { title: 'Home', icon: 'mdi-view-dashboard', route: '/' },
          { title: 'About', icon: 'mdi-information-outline', route: '/about' },
          { title: 'Members', icon: 'mdi-account-multiple', route: '/members' },
          { title: 'Calendar', icon: 'mdi-calendar', route: '/calendar' },
          { title: 'Idea List', icon: 'mdi-head-lightbulb-outline', route: '/idealist' },
          { title: 'Equipment List', icon: 'mdi-cog', route: '/equipmentlist' },
          { title: 'YouTube Statistics', icon: 'mdi-youtube', route: '/youtubestatistics' }
        ]
      }
      return items
    },
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    }
  },
  methods: {
    onLogOut () {
      this.$store.dispatch('logout')
      this.$router.push('/login')
    }
  }
}
</script>
<style>
</style>
